import config from 'config';

import { axiosClient } from '../../client';

export const faq = () => {
  return axiosClient.get('faq', {
    params: {
      'match[flow]': 'login-portalre',
      'match[items.brand]': config.app.short.toUpperCase(),
      'options[sort]': 'priority',
    },
  });
};
